import React from 'react'
import Content from '../components/Other Components/Content';

const Home = () => {
  return (
    <Content />
  )
}

export default Home